import { Component } from '@angular/core';

@Component({
    selector:    'ohp-skip-to-main',
    templateUrl: './skip-to-main.component.html'
  })
  export class SkipToMainComponent {}
